module.exports = __webpack_public_path__ + "static/media/EmailModalCross.7265e7e3.svg";